import { render, staticRenderFns } from "./tinfoLink.vue?vue&type=template&id=55b33530&"
import script from "./tinfoLink.vue?vue&type=script&lang=js&"
export * from "./tinfoLink.vue?vue&type=script&lang=js&"
import style0 from "./tinfoLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports